import Phaser from "phaser";
import type { MatchSnapshot } from "../../../../buckle-party/src/mergeborn/protocol";
import type { Side } from "../model/battle";
import { layoutFor } from "./BattlefieldView";
import { Effects } from "./Effects";
import { stageY } from "./stage";

// Keep ownership and readiness anchored above the actual team, including exchanged sides.
export class TeamStatusView {
  private labels: Phaser.GameObjects.Text[];
  private ready = [false, false];
  private notices = new Set<Phaser.GameObjects.Text>();
  constructor(private scene: Phaser.Scene, private effects: Effects, private motion: boolean, match: MatchSnapshot) {
    const sides: Side[] = [match.ownSide, match.ownSide === "player" ? "opponent" : "player"];
    this.labels = sides.map(side =>
      scene.add.text(layoutFor(scene, side).originX, layoutFor(scene, side).originY - stageY(side === "player" ? 71 : 101), "", {
        fontFamily: "Georgia, serif", fontSize: "24px", color: "#fff0cf", backgroundColor: "#213b34",
        padding: { x: 16, y: 9 }, align: "center",
      }).setOrigin(0.5).setDepth(610));
    this.refresh(match);
  }
  battleStarted(): void {
    this.labels.forEach(label => label.setVisible(false));
    this.notices.forEach(notice => { this.scene.tweens.killTweensOf(notice); notice.destroy(); });
    this.notices.clear();
  }
  refresh(match: MatchSnapshot): void {
    [match.own, match.other].forEach((member, i) => {
      const label = this.labels[i];
      label.setText(`${member.name}${i === 0 ? " · Your team" : ""}\n${member.ready ? "✓ Ready" : member.connected ? "Preparing" : "Reconnecting…"}`);
      label.setColor(member.ready ? "#caffd0" : i === 0 ? "#ffe6a1" : "#fff0cf");
      if (member.ready && !this.ready[i]) {
        const notice = this.scene.add.text(label.x, label.y + 70, `${member.name} Ready!`, {
          fontFamily: "Georgia, serif", fontSize: "30px", color: "#d8ffe0", stroke: "#213b34", strokeThickness: 5,
        }).setOrigin(0.5).setDepth(650);
        this.notices.add(notice);
        if (this.motion) this.effects.burst("ice", notice.x, notice.y + 12, 1.5);
        this.scene.tweens.add({ targets: notice, y: notice.y - (this.motion ? 35 : 0), alpha: 0,
          delay: 900, duration: 850, ease: "Sine.Out", onComplete: () => { this.notices.delete(notice); notice.destroy(); } });
      }
      this.ready[i] = member.ready;
    });
  }
}
